import { asApiFailure } from "@utils/apiFailure";

// Since OB-12 the API answers an email that already has an account or an
// application with the same 202 as any other, so the form never learns it and
// the existing customer is emailed instead. An environment still running the
// older API answers that email with a 409, and retrying can only repeat it, so
// the 409 keeps copy of its own (a fallback): never "try again", always the
// signup link and the Sign In control below the form.
const KNOWN_EMAIL =
    "There's already an account or application for this email. Check your inbox for your signup link, or sign in below.";

const GENERIC_FAILURE =
    "We couldn't submit your application. Please try again in a moment.";

export const applicationErrorMessage = (error: unknown): string =>
    asApiFailure(error)?.status === 409 ? KNOWN_EMAIL : GENERIC_FAILURE;
